import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../store/rootStore";
import constants from "../../configConstants";

const initialState = {
  user:
    constants.VITE_IS_AUTH_DISABLED === "true"
      ? {
          email: "devuser@example.com",
          first_name: "Dev",
          last_name: "User",
          groups: ["SuperAdmin"],
          is_authenticated: true,
        }
      : { email: "", first_name: "", last_name: "", is_authenticated: false, groups: [] },
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login(state, action) {
      state.user.email = action.payload.user.email;
      state.user.first_name = action.payload.user.first_name;
      state.user.last_name = action.payload.user.last_name;
      state.user.groups = action.payload.user.groups;
      state.user.is_authenticated = true;
    },
    logout(state) {
      state.user = initialState.user;
    },
  },
});

export const { login, logout } = authSlice.actions;

export const selectUser = (state: RootState) => state.auth.user;
export const isAuth = (state: RootState) => state.auth.user?.is_authenticated;
export const isAdmin = (state: RootState) => state.auth.user?.groups?.includes("Admin");
export const isSuperAdmin = (state: RootState) => state.auth.user?.groups?.includes("SuperAdmin");
export const isCustomer = (state: RootState) => state.auth.user?.groups?.includes("Customer");
export const isInGroup = (groupNames: string[]) => (state: RootState) =>
  state.auth.user?.groups.some((group) => groupNames.includes(group));

export const authReducer = authSlice.reducer;
